import { CDN_UPDATE_LOCAL_BROWSER_STATS } from '../constants/ActionTypes';

import { CDN_PROVIDERS } from '../constants/cdnConstants';

const initialState = {};

const ERR_OBJECT = { err: true };

const generateKey = function(city, path, cdnKey) {
    return `${city}-${path}-${cdnKey}`;
};

const requestError = function(action) {
    let data = {};
    Object.keys(CDN_PROVIDERS).forEach(cdnKey => {
        data[generateKey(action.city, action.path, cdnKey)] = ERR_OBJECT;
    });
    return data;
};

// Add data for missing CDNs, i.e. CDNs did not return any data from the server
const normalizeStats = function(action) {
    const normalizedStats = {};
    Object.keys(CDN_PROVIDERS).forEach(cdnKey => {
        if (!action.stats[cdnKey]) {
            // Add ERR data for the CDN
            normalizedStats[cdnKey] = ERR_OBJECT;
        } else {
            normalizedStats[cdnKey] = action.stats[cdnKey];
        }
    });
    return normalizedStats;
};

const extractData = function(action) {
    const data = {};
    const stats = normalizeStats(action);
    let fastest = undefined;

    Object.keys(stats).forEach(cdn => {
        // Accumulate data to add to state
        data[generateKey(action.city, action.path, cdn)] = stats[cdn];
        // Check for fastest cdn
        if (!fastest || !stats[cdn].err && stats[cdn].median < fastest.median) {
            fastest = {
                cdn,
                median: stats[cdn].median
            };
        }
    });
    data[generateKey(action.city, action.path, fastest.cdn)].isFastest = true;
    // Add fastest CDN for map
    data[action.city + '-' + action.path] = CDN_PROVIDERS[fastest.cdn];
    return data;
};

const getMedian = function(sortedNumbers) {
  if (!sortedNumbers.length) {
      return 0;
  }
  var middle = Math.floor(sortedNumbers.length / 2);
  var isEven = sortedNumbers.length % 2 === 0;
  return isEven ? (sortedNumbers[middle] + sortedNumbers[middle - 1]) / 2 : sortedNumbers[middle];
};

// Calculates the fastest CDN provider for a given prefix by the tuple {country, city, path} once all points
// for that tuple have settled
const toLocalDataPointKey = (action) => `${action.path}-${action.cdnKey}`;
const cdnProvidersRegex = /(-cf|-fy|-ak|-mc)/ig;

const calculateFastestPoint = function(cdnStats, action) {

        const currentPointId = toLocalDataPointKey(action);
        const fastestPoint = currentPointId;

        const pointDataKeys = Object.keys(cdnStats)
            // Local data points paths are encoded with the cdn name, e.g. http://idemo-ak.cloudinary....
            // To get all data point results we need to ignore the encoded CDN name
            .filter(key =>
                    (key.replace(cdnProvidersRegex, '') === action.path.replace(cdnProvidersRegex, '') // Strip CDN name from path
                    ));
        if (pointDataKeys.length < Object.keys(CDN_PROVIDERS).length) {
            return undefined;
        }
        return pointDataKeys.reduce((fastestPointId, currentPointId) => {
            // median is not defined in case of an error for a single DataPoint
            const currentMedian = cdnStats[currentPointId].median || Number.MAX_SAFE_INTEGER;
            const fastestMedian = cdnStats[fastestPointId].median || Number.MAX_SAFE_INTEGER;
            if (currentMedian< fastestMedian) {
                return currentPointId;
            }
            else {
                return fastestPointId;
            }
        }
        , currentPointId);
    };

const calculateStats = function(action) {
    const rawResults = action.stats;
    if (!action.stats || action.stats.length === 0) {
        return ERR_OBJECT;
    }
    rawResults.sort((a,b) => a - b);
    const median = getMedian(rawResults);
    if (median === 0) {
        return ERR_OBJECT;
    }
    return {
        mean: rawResults.reduce( ( accumulator, currentValue ) => accumulator + currentValue, 0 ) / rawResults.length,
        median,
        p10: rawResults[Math.floor(rawResults.length/10)],
        p90: rawResults[Math.floor(9*rawResults.length/10)],
        iterations: rawResults.length,
        all: rawResults
    };
};

function increaseResourceTimingBuffer(n) {
    var supported = typeof performance.setResourceTimingBufferSize == 'function';
    if (supported) {
        performance.setResourceTimingBufferSize(n);
    }
}

/*
 * Reset resource timing buffer if it is full (data is already persisted in the store)
 * Should probably be in a separate init file imported by _someone_
 */
function onResourceTimingBufferFull(event) {
    const bufferSize = performance.getEntriesByType('resource').length;
    increaseResourceTimingBuffer(bufferSize * 2);
}
if (typeof window !== 'undefined') {
  window.performance.onresourcetimingbufferfull = onResourceTimingBufferFull;
}


export default function (state = initialState, action) {
    let nextState;
    switch (action.type) {
        case CDN_UPDATE_LOCAL_BROWSER_STATS: {
          nextState = {
            [`${action.path}-${action.cdnKey}`]: calculateStats(action),
            ...state
          };
          // Mark fastest point if found
          const fastestPoint = calculateFastestPoint(nextState, action);
          if (fastestPoint) {
            const fastestStats = nextState[ fastestPoint ];
            fastestStats.isFastest = true;
          }
          return nextState;
        }
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/cdnStats.js
 **/